(ns common.schema.entities.rotation-period.schema
  (:require
   [common.schema.entities.rotation-period.option-source :as rotation-period-options]
   [common.schema.entities.rotation-period.options :as options]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :rotation-period/rotation-period-label
                          "Label"
                          {:authorization            su/access-user-user
                           :default-field-visibility :in-use-disabled
                           ;; The entity's display name is this label, so an
                           ;; unnamed rotation period renders as an empty row in
                           ;; the settings panel and as a blank option in the
                           ;; cycle's picker.
                           :mandatory-config         :mandatory/always})
    (su/keyword-field :rotation-period/rotation-type
                      "Rotation type"
                      options/rotation-type-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/keyword-field :rotation-period/rotation-period-status
                      "Status"
                      options/rotation-period-status-options
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
    (su/single-ref-field :rotation-period/default-template
                         "Default template"
                         [:entity.type/survey-template]
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use-disabled
                          ;; Mandatory because this is what a cycle resolves in
                          ;; order to know what to send. A rotation period
                          ;; without one resolves no template, and every profile
                          ;; in a mass send fails at send time rather than at
                          ;; configuration time.
                          :mandatory-config         :mandatory/always
                          ;; Scoped to the owning survey type: offering another
                          ;; type's template produces a cycle that sends the
                          ;; wrong questionnaire.
                          :option-filter-fn
                          rotation-period-options/template-for-rotation-period-survey-type
                          :os-filter-terms-fn
                          rotation-period-options/rotation-period-template-filter-terms
                          ;; A survey type with no templates of its own would
                          ;; otherwise be stuck: this field is mandatory and
                          ;; scoped, so its picker offers nothing and the
                          ;; rotation period cannot be saved at all. Typing a
                          ;; name now offers to create that template, already
                          ;; attached to the right survey type.
                          :create-on-fly?           true
                          :create-entity-types      [:entity.type/survey-template]
                          :create-start-value-fn
                          rotation-period-options/template-create-start-value})
    (su/text-edn-field :rotation-period/default-deadline-config
                       "Default deadline config"
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use-disabled}))))
